import { shallowEqual } from "react-redux";
import { useCarConfigSelector } from "../redux/store";
import { getTechSpecsLabelConfig } from "../utils/ecoUtils";
import { hasAlternativeEcoSpecFlow } from "../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { EcoLabelConfig } from "../../../shared-logic/types/Motorization";
import { TsBoolean } from "../../../../shared-logic/utils/commonUtils";

export const useAphEfficiencyLabel = (): EcoLabelConfig => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const techSpecs = useCarConfigSelector((state) => state.specs.techSpecs, shallowEqual);
    const flattenedTechSpecs = techSpecs.flatMap((spec) => spec.data || []).filter(TsBoolean);
    const alternativeEcoSpecFlow = hasAlternativeEcoSpecFlow(commonSettings);

    return getTechSpecsLabelConfig(flattenedTechSpecs, alternativeEcoSpecFlow);
};
